module.exports = __webpack_public_path__ + "static/media/downarrow.d9043f3b.png";